import React, { Component } from 'react';
import { connect } from 'react-redux';
import cookie from 'react-cookies';
import {
  updateSelectedSecondaryAccountValue,
  clearSelectedInvoices
} from "../../actions/InvoiceActions";
import SalesAreaData from '../../models/sales_area_data';
import PayerDetailRequest from '../../models/payer/PayerDetailRequest';
import { getInvoiceQuery, getSelectedPrimaryAccount, getPayerAccounts } from "./Selectors";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown} from "@fortawesome/free-solid-svg-icons";


export class PayerSelect extends Component {

  constructor(props) {
    super(props);
    this.handleCustomerChange = this.handleCustomerChange.bind(this);
  }

  handleCustomerChange = (e) => {
    clearSelectedInvoices(this.props.dispatch);
    updateSelectedSecondaryAccountValue(this.props.dispatch, e.target.value);
  };
  truncateOption(text) {
    const maxLength = 24;
    if (text.length > maxLength) {
      return text.substr(0, maxLength) + '...';
    }
    return text;
  }

  buildPayerDetailRequest() {
    const customerNumber = this.props.customerNumber;//cookie.load(`${this.props.currentUser.Login}${'_'}${'selectedHeaderPrimaryAcct'}`);
    const companyCode = cookie.load(`${this.props.currentUser.Login}${'_'}${'selectedCompanyCode'}`);
    const salesOrganization = cookie.load(`${this.props.currentUser.Login}${'_'}${'selectedSalesOrganization'}`);
    const selectedDistributionChannel = cookie.load(`${this.props.currentUser.Login}${'_'}${'selectedDistributionChannel'}`);
    const selectedDivision = cookie.load(`${this.props.currentUser.Login}${'_'}${'selectedDivision'}`);

    const salesAreaData = new SalesAreaData(
      salesOrganization,
      selectedDistributionChannel,
      selectedDivision,
    );
    return new PayerDetailRequest(customerNumber, companyCode, '', salesAreaData);
  }

  render() {
    let value = this.props.selectedSecondaryAccount;
    let options = this.props.payerAccounts.map((account, index) => {
      return { value: index, label: `${account.PrimaryAcct}-${account.Name}`, account_number: account.PrimaryAcct }
    });
    return <div className='customSelect payer-select'>
      <select 
        onChange={this.handleCustomerChange} 
        disabled={this.props.secondaryAccounts && this.props.secondaryAccounts.length <= 1}
        value={value}
        className="invoicesHeadingInput form-control">
        {options.map(option => {
          return (
            <option 
              key={option.value} 
              value={option.value}>
              {this.truncateOption(option.label)}
              </option>
            )
        })}
      </select>
      <FontAwesomeIcon icon={faChevronDown} className={"select-arrow"}/>
    </div>
  }
}

export default connect((state, props) => {
  return {
    selectedSecondaryAccount: state.user_options.selectedSecondaryAccount,
    secondaryAccounts: state.user_options.secondaryAccounts,
    selectedPrimaryAccount: getSelectedPrimaryAccount(state, props),
    currentUser: state.default.currentUser,
    customerNumber: state.user_options.selectedPrimaryAccount && state.user_options.selectedPrimaryAccount.PrimaryAcct,
    invoiceSearchQuery: getInvoiceQuery(state, props),
    payerAccounts: getPayerAccounts(state, props),
  }
})(PayerSelect);